function formateHours(time) {
    const hours = Math.floor(time / 60 / 60);
    const minutes = Math.floor((time / 60) % 60);
    const seconds = Math.floor(time % 60);
    var hours1 = hours < 10 ? "0" + hours : hours;
    var minutes1 = minutes < 10 ? "0" + minutes : minutes;
    var seconds1 = seconds < 10 ? "0" + seconds : seconds;
    return hours1 + ":" + minutes1 + ":" + seconds1;
}
//格式时间， yyyy-MM-dd HH:mm:ss
function formatTime(time) {
    let date = new Date(time);
    let getFullYear = date.getFullYear();
    let getMonth = date.getMonth() + 1;
    let getDate = date.getDate();
    let getHours = date.getHours();
    let getMinutes = date.getMinutes();
    let getSeconds = date.getSeconds();
    if (getMonth < 10) {
        getMonth = "0" + getMonth;
    }
    if (getDate < 10) {
        getDate = "0" + getDate;
    }
    if (getHours < 10) {
        getHours = "0" + getHours;
    }
    if (getMinutes < 10) {
        getMinutes = "0" + getMinutes;
    }
    if (getSeconds < 10) {
        getSeconds = "0" + getSeconds;
    }
    date =
        getFullYear +
        "-" +
        getMonth +
        "-" +
        getDate +
        " " +
        getHours +
        ":" +
        getMinutes +
        ":" +
        getSeconds;
    return date;
}
export { //很关键
    formateHours,
    formatTime
}